import { render, staticRenderFns } from "./Jobdetail.vue?vue&type=template&id=0a38f56b"
import script from "./Jobdetail.vue?vue&type=script&lang=ts"
export * from "./Jobdetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports